import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const without = ['Presupuestos a mano', 'Precios "a ojo"', 'Stock sin control', 'Agenda en papel', 'Sin contratos', 'Horas administrativas'];
const withKit = ['Presupuesto en 5 min', 'Costo real por hora', 'Alerta de reposición', 'Agenda semanal clara', '4 contratos listos', 'Horas para atender'];
export function Comparison() {
  return <section className="px-4 py-10" data-id="element-38" data-mp="1uwfhavef1uwp">
      <h2 className="text-center text-xl font-black text-white" data-id="element-39" data-mp="1uzbj4utdx3qf">
        Sin Kit Consultorio Sencillo{' '}
        <span className="text-teal-300" data-id="element-40" data-mp="1zy4rk8tte4jq">vs</span> Con Kit Consultorio Sencillo
      </h2>

      <div className="mt-5 grid grid-cols-2 gap-2" data-id="element-41" data-mp="23vsvu2hed9oa">
        <div className="rounded-2xl border border-red-400/20 bg-red-500/10 p-3" data-id="element-42" data-mp="28vxadmyqvubv">
          <p className="mb-2 text-center text-[11px] font-extrabold uppercase tracking-wide text-red-200" data-id="element-43" data-mp="9ke0n65mai15">
            Sin el Kit
          </p>
          <ul className="space-y-2" data-id="element-44" data-mp="ej7gv6cagn50">
            {without.map(t => <li key={t} className="flex items-start gap-1.5" data-id="element-45" data-mp="1m1qy3ajihmbi">
                <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-red-300" aria-hidden="true" data-id="element-46" data-mp="1ha8yapt85rs4" />
                <span className="text-[12px] leading-snug text-red-50" data-id="element-47" data-mp="1d8x56ab56of6">
                  {t}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="rounded-2xl border border-teal-400/30 bg-teal-500/15 p-3" data-id="element-48" data-mp="24zutz3ae1ovd">
          <p className="mb-2 text-center text-[11px] font-extrabold uppercase tracking-wide text-teal-200" data-id="element-49" data-mp="20xgfevdr5b9w">
            Con el Kit
          </p>
          <ul className="space-y-2" data-id="element-50" data-mp="1vx23v3cxzj74">
            {withKit.map(t => <li key={t} className="flex items-start gap-1.5" data-id="element-51" data-mp="1qyqvyy67jirj">
                <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-teal-300" aria-hidden="true" data-id="element-52" data-mp="kjgh1ouk1tor" />
                <span className="text-[12px] leading-snug text-teal-50" data-id="element-53" data-mp="fj2906syejqq">
                  {t}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}